export const SITE = {
  whatsappNumber: "5215555555555", // placeholder
  whatsappMessage: "Hola, quiero información sobre la franquicia digital Kairós Learning.",
  email: "inversiones@kairoslearning.com",
  phoneDisplay: "+52 55 5555 5555",
  // Deadline for the current territory allocation round
  deadline: "2026-07-31T23:59:59",
  territoriesLeft: 7,
};

export const CAPITAL_RANGES = [
  "Menos de $10,000 USD",
  "$10,000 – $25,000 USD",
  "$25,000 – $50,000 USD",
  "$50,000 – $100,000 USD",
  "Más de $100,000 USD",
];

export const COUNTRIES = [
  "México", "Colombia", "Perú", "Chile", "Argentina", "Ecuador",
  "Guatemala", "República Dominicana", "Costa Rica", "Panamá",
  "Bolivia", "Uruguay", "Paraguay", "El Salvador", "Honduras",
  "Estados Unidos", "España", "Otro",
];
